import { ReactNode, useRef } from "react";
import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";
import AppHeader from "../../features/header/AppHeader";
import { AppContext } from "../../layout/AppContext";

interface BackofficeLayoutProps {
  children: ReactNode;
  submenu?: ReactNode;
}

const BackofficeLayout = ({ children, submenu }: BackofficeLayoutProps) => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout className="MyServiceLayout bg-lighter height-500">
        <ApplicationLayout.Header>
          <AppHeader
            navItems={[
              {
                key: "backoffice/consultants",
                value: "Consultores",
              },
              {
                key: "backoffice/failures",
                value: "Literatura técnica",
              },
              {
                key: "backoffice/steps",
                value: "Etapas de Ocorrência",
              },
              {
                key: "backoffice/budget",
                value: "Orçamento",
              },
            ]}
          />
        </ApplicationLayout.Header>
        <ApplicationLayout.Body className="uikitDemo" navigation={submenu}>
          {children}
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default BackofficeLayout;
